// =============================================================================
//  brandTheme.ts  -  v1 RESTAURE (audit & confiance)
//
//  Palette officielle :
//   - Bleu acier #1F3D5C : primaire (serieux / regulatoire)
//   - Teal       #2E8B96 : secondaire (accent positif / "365")
//   - Ambre      #D9842B : accent (warnings semantiques)
//
//  Note : la variante v2 "EU compliance" (bleu UE + or etoile) est conservee
//  dans brandTheme.eu.ts si on veut re-experimenter. Le dark mode reste
//  retire (cf hooks/useTheme + components/ThemeProvider).
// =============================================================================

import {
  BrandVariants,
  createLightTheme,
  Theme,
} from '@fluentui/react-components';

const interFontStack =
  "'Inter', 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, " +
  "'Helvetica Neue', Arial, sans-serif";

export const auditBlue: BrandVariants = {
  10:  '#040810',
  20:  '#0A111E',
  30:  '#0F1B2C',
  40:  '#14253A',
  50:  '#192F48',
  60:  '#1A364F',
  70:  '#1B3955',
  80:  '#1F3D5C',  // primary
  90:  '#264A6E',
  100: '#2E5780',
  110: '#386592',
  120: '#4475A5',
  130: '#5E8AB5',
  140: '#83A4C5',
  150: '#B0C5D8',
  160: '#DCE5EE',
};

const lightBase = createLightTheme(auditBlue);

export const lightTheme: Theme = {
  ...lightBase,
  fontFamilyBase:     interFontStack,
  fontFamilyNumeric:  interFontStack,
};

// Compat : darkTheme = lightTheme. Le dark mode est retire en v2 mais on
// garde l export pour ne pas casser les imports historiques.
export const darkTheme: Theme = lightTheme;

export const chartColors = [
  '#1F3D5C',
  '#2E8B96',
  '#D9842B',
  '#5E8AB5',
  '#5DAFB8',
];

export const statusColors = {
  pass:            '#1F7A45',
  passBg:          '#E6F4EC',
  warning:         '#A86317',
  warningBg:       '#FDF1E2',
  fail:            '#B82329',
  failBg:          '#FBE7E7',
  manual:          '#5B4E89',
  manualBg:        '#EFEAF5',
  notApplicable:   '#5C5C5C',
  notApplicableBg: '#EDEDED',
  error:           '#7A1F23',
  errorBg:         '#F5D6D7',
};

export const brand = {
  primary:        '#1F3D5C',
  primaryRgb:     [31, 61, 92] as [number, number, number],
  primaryHexDocx: '1F3D5C',

  secondary:        '#2E8B96',
  secondaryRgb:     [46, 139, 150] as [number, number, number],
  secondaryHexDocx: '2E8B96',

  accent:        '#D9842B',
  accentRgb:     [217, 132, 43] as [number, number, number],
  accentHexDocx: 'D9842B',

  gradient: {
    from: '#1F3D5C',
    to:   '#2E8B96',
  },
};
